// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ZSgG","productName":"Table_productName__1p9r5"};